import React, { useRef, useCallback, useEffect, useState } from 'react';
import { loadMapApi, parseGoogleAddress, ParseGoogleAddressResult } from 'helpers';
import { Address } from 'graphql/types';
import { Input, InputRef } from 'antd';

interface SearchBoxProps {
  placeholder?: string;
  onChange?: (place: ParseGoogleAddressResult) => void;
  value?: Address;
}

function SearchBox({ onChange = () => { }, value, placeholder = 'Enter your Location Address ...' }: SearchBoxProps) {
  const input = useRef<InputRef>(null);
  const searchBox = useRef<any>();
  const [scriptLoaded, setScriptLoaded] = useState(false);
  const [location, setLocation] = useState(''); // State to manage input value

  useEffect(() => {
    setLocation(value?.address);
  }, [value]);

  const onPlacesChanged = useCallback(() => {
    const places = searchBox.current.getPlaces();
    const result = parseGoogleAddress(places[0]);
    if (result) {
      onChange(result);
      setLocation(result?.address);
    }
  }, [onChange]);

  useEffect(() => {
    const { script, loaded } = loadMapApi();
    const setScript = () => {
      setScriptLoaded(true);
    };
    if (loaded) {
      setScript();
    } else {
      script.addEventListener('load', setScript);
    }
  }, []);

  useEffect(() => {
    if (scriptLoaded && input.current && (window as any)?.google && (window as any)?.google?.maps?.places) {
      searchBox.current = (window as any).google && new (window as any).google.maps.places.SearchBox(input.current.input);
      searchBox.current.addListener('places_changed', onPlacesChanged);
    }
  }, [onPlacesChanged, scriptLoaded]);

  return (
    <Input
      ref={input}
      placeholder={placeholder}
      value={location} // Controlled value
      onChange={(e) => setLocation(e.target.value)}
    />
  );
}

export default SearchBox;
